const SLEEP_DELAY = 1000;
const MAX_SLEEP_DELAY = 10000;

export const sleep = (ms: number = SLEEP_DELAY): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const sleepValue = (ms: string): Promise<void> => {
  const parsed = Number(ms);
  if (!isNaN(parsed) && parsed > SLEEP_DELAY) {
    return sleep(Math.min(parsed, MAX_SLEEP_DELAY));
  }

  // fallback to default
  return sleep();
};
